import { render } from "./Labels.vue?vue&type=template&id=825d9ee2&scoped=true&ts=true"
import script from "./Labels.vue?vue&type=script&lang=ts"
export * from "./Labels.vue?vue&type=script&lang=ts"

import "./Labels.vue?vue&type=style&index=0&id=825d9ee2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-825d9ee2"]])

export default __exports__